enum RealtimeOperation {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
    ACTIVATE = 'ACTIVATE'
}

export default RealtimeOperation